import { formateDateToJalali, genderConverter } from "../../../utils/Functions";

const UserProfile = ({ profile }: any) => {
  function convertDateFormat(dateTime: any) {
    const [date] = dateTime.split(" ");
    const [day, month, year] = date.split("-");
    return `${year}/${month}/${day}`;
  }

  const Card = ({ title, content, isLtr }: any) => {
    return (
      <div className="bg-pr_yellow px-6 py-4 lg:py-10 rounded-xl">
        <h2>{title}</h2>
        <h1
          className="font-rokh font-[900] mt-2 text-lg text-right"
          style={{ direction: isLtr ? "ltr" : "rtl" }}
        >
          {content ?? "وارد نشده"}
        </h1>
      </div>
    );
  };

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 mt-2">
        <Card
          title="نام و نام‌خانوادگی:"
          content={
            profile.user.first_name
              ? `${profile.user.first_name} ${profile.user.last_name}`
              : "وارد نشده"
          }
        />
        <Card
          title="تاریخ عضویت:"
          content={convertDateFormat(profile.created_at_jalali)}
          isLtr
        />
        <Card
          title="تاریخ تولد:"
          content={formateDateToJalali(profile.birth_day)}
          isLtr
        />
        <Card title="جنسیت:" content={genderConverter(profile.gender)} />
        <Card title="شماره همراه:" content={profile.mobile} />
        <Card title="ایمیل:" content={profile.email} />
        <Card title="کاربران ایجاد شده:" content={profile.temp_user_count} />
        <Card title="تست‌های بارگذاری شده:" content={profile.test_count} />
      </div>
    </div>
  );
};

export default UserProfile;
